export default __webpack_public_path__ + "static/media/3.ecfc5e04.jpg";